import z from "zod";

import { ProjectStatus } from "@/features/projects/types";

export const createProjectSchema = z.object({
  name: z.string().min(4, "Name must be at least 4 characters long").max(64, "Name exceeds the maximum length of 64 characters"),

  description: z.string().max(256, "Description exceeds the maximum length of 256 characters"),
});

export const updateProjectSchema = z.object({
  id: z.string(),

  name: z.string().min(4, "Name must be at least 4 characters long").max(64, "Name exceeds the maximum length of 64 characters"),

  description: z.string().max(256, "Description exceeds the maximum length of 256 characters").optional(),

  status: z.enum(["Active", "On hold", "Complete"] as const satisfies readonly ProjectStatus[]),
});

export const deleteProjectSchema = z.object({
  id: z.string(),
});

export const leaveProjectSchema = z.object({
  id: z.string(),
});

export const inviteUserSchema = z.object({
  projectId: z.string(),
  emailAddress: z.string().email("Please enter a valid email address"),
  roleId: z.string().min(1, "Please select a role"),
});

export const revokeInvitationSchema = z.object({
  projectId: z.string(),
  invitationId: z.string(),
});

export const updateMemberSchema = z.object({
  projectId: z.string(),
  memberId: z.string(),
  roleId: z.string().min(1, "Please select a role"),
});

export const removeMemberSchema = z.object({
  projectId: z.string(),
  memberId: z.string(),
});

export type CreateProjectSchema = z.infer<typeof createProjectSchema>;
export type UpdateProjectSchema = z.infer<typeof updateProjectSchema>;
export type DeleteProjectSchema = z.infer<typeof deleteProjectSchema>;
export type LeaveProjectSchema = z.infer<typeof leaveProjectSchema>;
export type InviteUserSchema = z.infer<typeof inviteUserSchema>;
export type RevokeInvitationSchema = z.infer<typeof revokeInvitationSchema>;
export type UpdateMemberSchema = z.infer<typeof updateMemberSchema>;
export type RemoveMemberSchema = z.infer<typeof removeMemberSchema>;
